import { useRef } from 'react';
import Slider from 'react-slick';

import './slick.css';
import './testimonials.scss';

const TestimonialsCarousel = ({ children }) => {
  const sliderRef = useRef(null);

  return (
    <div className="testimonials-carousel-container custom-buttons">
      <Slider
        ref={sliderRef}
        slidesToShow={3}
        slidesToScroll={2}
        className={'testimonials-carousel'}
        dots={false}
        infinite={false}
        speed={600}
      >
        {children}
      </Slider>
    </div>
  );
};

export default TestimonialsCarousel;
